import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";
import { useSession } from "../app/session.js";
import { fetchTwoFactorStatus, listPasskeys } from "../api/security.js";
import type { PasskeyMeta, TwoFactorStatus } from "../api/security.js";

export const TWO_FACTOR_KEY: ReadonlyArray<string> = ["security", "two-factor"];
export const PASSKEYS_KEY: ReadonlyArray<string> = ["security", "passkeys"];

export function useTwoFactorStatus(): UseQueryResult<TwoFactorStatus, Error> {
  const unlocked = useSession().state.status === "unlocked";
  return useQuery<TwoFactorStatus, Error>({ queryKey: TWO_FACTOR_KEY, queryFn: fetchTwoFactorStatus, enabled: unlocked });
}

export function usePasskeys(): UseQueryResult<PasskeyMeta[], Error> {
  const unlocked = useSession().state.status === "unlocked";
  return useQuery<PasskeyMeta[], Error>({ queryKey: PASSKEYS_KEY, queryFn: listPasskeys, enabled: unlocked });
}
